import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import {
  generateDomainsNameStrategy,
  generateRedditDomainsNameStrategy
} from 'utils/insightModal/strategy/searchFilterComposing'

const useSearchFilterComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const searchFilterComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.ALL_SOURCES:
      case InsightViewOption.BLOGS:
      case InsightViewOption.FORUMS:
      case InsightViewOption.NEWS:
        return generateDomainsNameStrategy()
      case InsightViewOption.SUBREDDITS:
        return generateRedditDomainsNameStrategy()
      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption])

  return searchFilterComposingStrategy
}

export default useSearchFilterComposingStrategy
